import { render, staticRenderFns } from "./TCMPharmacy.vue?vue&type=template&id=5decc72a&"
import script from "./TCMPharmacy.vue?vue&type=script&lang=js&"
export * from "./TCMPharmacy.vue?vue&type=script&lang=js&"
import style0 from "./TCMPharmacy.vue?vue&type=style&index=0&id=5decc72a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports